import React from 'react';
import { LinkButton, Button } from '../SubComponents/Buttons';
import { Input } from '../SubComponents/Inputs';
import { Row } from '../SubComponents/Modals';
import { Label } from '../SubComponents/Text';
import useLocalize from '../Hooks/useLocalize';

export interface VoucherProps {
  isOpen: boolean;
  onOpen: (isOpen: boolean) => void;
  code: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  vouchers: { isOpen: boolean; code: string }[];
  applyVoucher: (code: string) => void;
  error?: string;
  loading?: boolean;
}

const Voucher = ({
  isOpen,
  onOpen,
  code,
  onChange,
  vouchers,
  applyVoucher,
  error,
  loading,
}: VoucherProps) => {
  const localize = useLocalize();

  // TODO: put in logic to only show the 'additional voucher' button if user has entered a giftcard
  // or voucher refund voucher

  return (
    <>
      {isOpen && (
        <Row layout justifyContent="space-between" mb="3">
          <Input
            type="text"
            name="voucherCode"
            placeholder={localize('product.voucherCode')}
            onChange={onChange}
            value={code}
            mb="3"
          />

          <div>
            <Button
              variableWidth
              minWidth="145px"
              onClick={applyVoucher}
              loading={loading}
            >
              {localize('product.applyVoucher')}
            </Button>

            <LinkButton onClick={() => onOpen(false)} ml="2">
              {localize('product.cancel')}
            </LinkButton>
          </div>
        </Row>
      )}

      {vouchers.length >= 1 && (
        <Label mb="3" style={{ display: 'block' }}>
          {localize('product.voucherApplied')}
        </Label>
      )}

      {!isOpen && (
        <Button
          variableWidth
          minWidth="145px"
          onClick={() => onOpen(true)}
          loading={loading}
          size="small"
        >
          {localize('product.haveAVoucher')}
        </Button>
      )}

      {error && (
        <Label error mb="3" style={{ display: 'block' }}>
          {error}
        </Label>
      )}
    </>
  );
};

export default Voucher;
